/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { IListItemData } from '../interfaces/IListItemData';

@Component({
	selector: 'app-list-item',
	templateUrl: './list-item.component.html',
	styleUrls: ['./list-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemComponent<T> {
	@Input() public item: T;
	@Input() public itemData: IListItemData;
	@Input() public highlight: boolean;
	@Input() public dragAndDropEnabled: boolean;

	@Output() public itemClickedEvent = new EventEmitter<T>();

	public onClick(): void {
		this.itemClickedEvent.emit(this.item);
	}
}
